export const FirebaseRemoteSettings = {
    FANTASY_DEPOSIT_PREFILLED_AMOUNT: 'fantasy_deposit_prefill_amount',
    FANTASY_FTD_PREFILLED_AMOUNT: 'fantasy_FTD_prefilled_amount',
    SPORTSBOOK_DEPOSIT_PREFILLED_AMOUNT: 'sportsbook_deposit_prefilled_amount',
    SPORTSBOOK_FTD_PREFILLED_AMOUNT: 'sportsbook_FTD_prefilled_amount',
    KYC_DOB_FIRST: 'kyc_dob_first',
    FANTASY_CASHOUT_ENABLED: 'fantasy_cashout_enabled',
    FANTASY_KEEP_LIVE_REMOVED_PROJECTIONS: 'fantasy_keep_live_removed_projections',
};
